import { toast, ToastOptions } from 'react-toastify';

export const toastVariant = (
	text: string,
	isError = false,
	toastId?: string,
	opts: ToastOptions = {},
) => {
	const params: ToastOptions = {
		className: 'w-max text-center z-[2000]',
		position: 'top-center',
		autoClose: 3000,
		hideProgressBar: true,
		closeOnClick: false,
		pauseOnHover: true,
		closeButton: false,
		draggable: true,
		theme: 'light',
		toastId,
		...opts,
	};
	return isError ? toast.error(text, params) : toast.success(text, params);
};
